import { createApi, fakeBaseQuery, SkipToken } from "@reduxjs/toolkit/dist/query/react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "@/firebase";
import { User } from "@/types";
import { ApiError } from "@/types/api";
import { addUser } from "@/store/usersSlice";

export const usersApi = createApi({
  reducerPath: "users",
  baseQuery: fakeBaseQuery<ApiError>(),
  tagTypes: ["userOrganizations"],
  endpoints: (builder) => ({
    fetchProfile: builder.query<User, string | SkipToken>({
      queryFn: async (userId, { dispatch }) => {
        const docRef = doc(db, `users/${String(userId)}`);
        const snapshot = await getDoc(docRef);

        if (snapshot.exists()) {
          const profile = { ...snapshot.data(), uid: userId };
          dispatch(addUser(profile));

          return {
            data: profile,
          };
        }

        return {
          error: {
            status: 404,
            statusText: "Usuario no encontrado",
          },
        };
      },
    }),
    createProfile: builder.mutation<User, Partial<User> | SkipToken>({
      queryFn: async (user, { dispatch }) => {
        if (!user?.uid) {
          return {
            error: {
              status: 400,
              statusText: "Petición inválida",
            },
          };
        }

        const payload = {
          ...user,
          createdBy: user.uid,
          createdAt: Date.now(),
        };

        try {
          const collectionRef = doc(db, `users/${user?.uid}`);
          await setDoc(collectionRef, payload);
          dispatch(addUser(payload));

          return {
            data: user.uid,
          };
        } catch (error) {
          return {
            error: {
              status: 500,
              statusText: "Error al crear el perfil",
            },
          };
        }

      },
    }),
  }),
});

export const { useFetchProfileQuery, useLazyFetchProfileQuery, useCreateProfileMutation } = usersApi;
